import React, { Component } from 'react';
import { Modal, Form, Input, Button, Header } from 'semantic-ui-react';
import { observer } from 'mobx-react';
import StandardOperationSelector from '../standard-operations/StandardOperationSelector';

class LabourForm extends Component {
  
  state = {
    isSelectorOpen: false
  }

  openStandardOperationSelector = () => {
    this.setState({ isSelectorOpen: true })
  }

  closeStandardOperationSelector = () => this.setState({ isSelectorOpen: false })

  applySelectedOperation = operation => {
    this.props.model.setDescription(operation.description)
    this.props.model.setMinutesPerSetup(operation.minutesPerSetup)
    this.props.model.setSecondsPerOperation(operation.secondsPerOperation)
    this.closeStandardOperationSelector()
  }

  selectAll = event => event.target.select()

  render() { 
    const {
      description,
      comment,
      numberOfSetups,
      minutesPerSetup,
      numberOfOperations,
      secondsPerOperation,
      extraMinutesPerUnit
    } = this.props.model
    return (
      <div>
        <StandardOperationSelector
          isOpen={this.state.isSelectorOpen}
          onClose={this.closeStandardOperationSelector}
          onSelectItem={this.applySelectedOperation}
        />
        <Modal size='small' open>
          <Modal.Header content='Job Labour' />
          <Modal.Content>
            <Form onSubmit={this.handleSubmit}>
              <Form.Group>
                <Form.Field width={16}>
                  <label>Operation</label>
                  <Input action value={description} onChange={this.handleChangeDescription}>
                    <input/>
                    <Button primary onClick={this.openStandardOperationSelector}>Standard Operations</Button>
                  </Input>
                </Form.Field>
              </Form.Group>
              <Form.Input value={comment} onChange={this.handleChangeComment} label='Comment' />
              <Header sub content='Set up' />
              <Form.Group widths='equal'>
                <Form.Field>
                  <Input 
                    fluid 
                    type='number' 
                    value={numberOfSetups} 
                    onChange={this.handleChangeNumberOfSetups} 
                    label='times' 
                    labelPosition='right' 
                    onFocus={this.selectAll}
                  />
                </Form.Field>
                <Form.Field>
                  <Input 
                    fluid 
                    type='number' 
                    value={minutesPerSetup} 
                    onChange={this.handleChangeMinutesPerSetup} 
                    label='minutes each' 
                    labelPosition='right' 
                    onFocus={this.selectAll}
                  />
                </Form.Field>
              </Form.Group>
              <Header sub content='Operations' />
              <Form.Group widths='equal'>
                <Form.Field>
                  <Input 
                    fluid 
                    type='number' 
                    value={numberOfOperations} 
                    onChange={this.handleChangeNumberOfOperations} 
                    label='ops' 
                    labelPosition='right' 
                    onFocus={this.selectAll}
                  />
                </Form.Field>
                <Form.Field>
                  <Input 
                    fluid 
                    type='number' 
                    value={secondsPerOperation} 
                    onChange={this.handleChangeSecondsPerOperation} 
                    label='seconds each' 
                    labelPosition='right' 
                    onFocus={this.selectAll}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Field>
                <label>Extra time per complete unit</label>
                <Input 
                  type='number' 
                  value={extraMinutesPerUnit} 
                  onChange={this.handleChangeExtraMinutesPerUnit} 
                  label='minutes' 
                  labelPosition='right' 
                  onFocus={this.selectAll}
                />
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button type='button' positive disabled={!this.props.model.isValid} onClick={this.props.onSave}>Save</Button>
            <Button type='button' negative onClick={this.props.onCancel}>Cancel</Button>
          </Modal.Actions>
        </Modal>
      </div>
    )
  }

  handleChangeDescription = event => {
    this.props.model.setDescription(event.target.value)
  }

  handleChangeComment = event => {
    this.props.model.setComment(event.target.value)
  }

  handleChangeNumberOfSetups = event => {
    var parsedValue = parseInt(event.target.value, 10)
    if (!isNaN(parsedValue)) this.props.model.setNumberOfSetups(parsedValue)
  }

  handleChangeMinutesPerSetup = event => {
    var parsedValue = parseInt(event.target.value, 10)
    if (!isNaN(parsedValue)) this.props.model.setMinutesPerSetup(parsedValue)
  }

  handleChangeNumberOfOperations = event => {
    var parsedValue = parseInt(event.target.value, 10)
    if (!isNaN(parsedValue)) this.props.model.setNumberOfOperations(parsedValue)
  }

  handleChangeSecondsPerOperation = event => {
    var parsedValue = parseInt(event.target.value, 10)
    if (!isNaN(parsedValue)) this.props.model.setSecondsPerOperation(parsedValue)
  }

  handleChangeExtraMinutesPerUnit = event => {
    var parsedValue = parseFloat(event.target.value)
    if (!isNaN(parsedValue)) this.props.model.setExtraMinutesPerUnit(parsedValue)
  }
}
 
export default observer(LabourForm);


// WEBPACK FOOTER //
// ./src/components/jobs/LabourForm.js